"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factsApi = void 0;
exports.factsApi = (http, prefix = '/facts') => ({
    getByAccount: (accountId, includeProperties) => {
        if (includeProperties)
            return http.get(prefix + `/account/${accountId}/fact?include_properties=true`);
        return http.get(prefix + `/account/${accountId}/fact`);
    },
    getTypeForAccount: (accountId, type) => {
        return http.get(prefix + `/account/${accountId}/fact/${type}`);
    },
    getByProperty: (propertyId) => {
        return http.get(prefix + `/property/${propertyId}/fact`);
    },
    getTypeForProperty: (propertyId, type) => {
        return http.get(prefix + `/property/${propertyId}/fact/${type}`);
    },
    setFactForAccount: (accountId, type, fact) => {
        return http.put(prefix + `/account/${accountId}/fact/${type}`, fact);
    },
    setFactForProperty: (propertyId, type, fact) => {
        return http.put(prefix + `/property/${propertyId}/fact/${type}`, fact);
    },
});
//# sourceMappingURL=index.js.map